import { EntityRatingCommentCount, Partner } from '@medprev-web-app/api-graphql-client';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { ReactNode } from 'react';

import { EntityProfileActions } from '@/app/(main)/(pages)/_components/entities/entity-profile-actions.component';
import { EntityProfileHeader } from '@/app/(main)/(pages)/_components/entities/entity-profile-header.component';
import { EntityAvatar } from '@/components/ui/avatar/entity-avatar';
import { resolvePartnerName } from '@/utils/partner/partner.util';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface PartnerProfileHeaderProps {
  partner: Partner;
  commentsCount?: EntityRatingCommentCount | null;
  scheduleAction?: ReactNode;
}

function resolvePlace(partner: Partner): string {
  const facility = partner.facilities?.[0];

  if (!facility?.city) {
    return '';
  }

  const place = [facility.city, facility.state].filter(Boolean).join(' - ');

  return facility.neighborhood ? `${facility.neighborhood} • ${place}` : place;
}

export function PartnerProfileHeader({ partner, commentsCount, scheduleAction }: PartnerProfileHeaderProps) {
  const partnerName = resolvePartnerName(partner);
  const place = resolvePlace(partner);

  return (
    <EntityProfileHeader
      dataTestId={DataTestIdEnum.PARTNER_PROFILE_HEADER}
      name={partnerName}
      rating={partner.facilities?.[0]?.rating}
      commentsCount={commentsCount}
      ratingAnalyticsEvent={AnalyticsEnum.CLICK_PARTNER_REVIEW}
      subtitle={place && <span className="block text-sm leading-5 text-gray-700">{place}</span>}
      avatar={(
        <EntityAvatar
          src={partner.avatar}
          size="xxxl"
          alt={`Foto de perfil de ${partnerName}`}
          type={EntityTypeEnum.CLINIC}
          shouldAddLightbox
          priority
          data-analytics-event={AnalyticsEnum.CLICK_PARTNER_AVATAR}
        />
      )}
      actions={(
        <EntityProfileActions
          entityType={EntityTypeEnum.CLINIC}
          entity={partner}
          scheduleAction={scheduleAction}
        />
      )}
    />
  );
}
